import React, { useContext, useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { getStudentsDetailsByBranch, sendAnnouncement } from '../../redux/features/student/studentSlice';
import useToast from '../../shared/Toast';
import Header from '../header/Header'
import Select from "react-select";
// import MultiSearchSelect from "react-search-multi-select";
import "./index.css"
import AppContext from '../../storage/AppContext';
import { getTemplates } from '../../redux/features/template/templateSlice';
import { Editor } from "react-draft-wysiwyg";
import { EditorState, ContentState, convertToRaw } from 'draft-js';
import draftToHtml from "draftjs-to-html"
import htmlToDraft from 'html-to-draftjs';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import * as constants from '../../config/config'

function Announcements() {

    let isEmptyFields = false

    const [admissions,setAdmissions] = useState([]);
    const [title,setTitle] = useState("");
    const [message,setMessage] = useState("");
    const [date,setDate] = useState("Now");
    const [isSchedule,setIsSchedule] = useState(false)
    const [scheduleDate,setScheduleDate] = useState("");

    const [classValue,setClassValue] =  useState("");
    const [isClassSelected,setIsClassSelected] = useState(false)

    const [sectionValue,setSectionValue] = useState("");
    const [isSectionSelected, setIsSectionSelected] = useState(false)

    const [templateValue,setTemplateValue] = useState('')
    const [editorState, setEditorState] = useState(EditorState.createEmpty())

    const [showMenu,setShowMenu] = useState(false)

    const dispatch = useDispatch()
    const showToast = useToast()
    const appContext = useContext(AppContext);
    const userDetails = appContext?.userDetails

    const sendAnnouncementDetails = useSelector(state => state.student.sendAnnouncementDetails)
    const studentsDetails = useSelector(state => state?.student?.allStudentsDetails)
    const templateDetails = useSelector(state => state.template.getTemplateDetails)
    
    const filteredTemplates = templateDetails?.data?.filter(eachTemplate => (!eachTemplate.isDeleted && eachTemplate.status !== constants.pending))
    
    useEffect(() => {
        dispatch(getTemplates({branch: userDetails?.data?.branch}))
    },[])

    const onChangeTemplate = (e) => {
        setTemplateValue(e.target.value)
        const templateDetails = filteredTemplates.find(each => each.title === e.target.value)
        setTitle(templateDetails?.title)
        setMessage(templateDetails?.message)
        const contentBlock = htmlToDraft(templateDetails?.message);
        const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
        setEditorState(EditorState.createWithContent(contentState))
    }

    useEffect(() => {
        convertContentToHTML()
    },[editorState])

    const handleEditorChange = (e) => {
        setEditorState(e);
    }
    const convertContentToHTML = () => {
        const rawContentState = convertToRaw(editorState.getCurrentContent());
        const currentContentAsHTML = draftToHtml(rawContentState);
        setMessage(currentContentAsHTML);
    }

    const uniqueClasses = []
    for(let eachStudent of studentsDetails?.data){
        if(!uniqueClasses.includes(eachStudent.class)){
            uniqueClasses.push(eachStudent.class)
        }
    }

    const classOptions = uniqueClasses.map(eachClass => {
        return {label: eachClass, value: eachClass}
    })

    const classValues = [{label: "Select All", value: "All"},...classOptions]

    const uniqueSections = []
    for(let eachStudent of studentsDetails?.data){
        if(!uniqueSections.includes(eachStudent.section) && eachStudent.class === classValue.value){
            uniqueSections.push(eachStudent.section)
        }
    }

    const sectionOptions = uniqueSections.map(eachSection =>{
        return {label: eachSection, value: eachSection}
    })

    const sectionValues = [{label: "Select All", value: "All"},...sectionOptions]

    const onChangeClass = (data) => {
        setClassValue(data)
        if(data.value === "All"){
            setIsSectionSelected(false)
            setSectionValue("")
            setIsClassSelected(false)
            const studentAdmissionNumbers = []
            for (let eachStudent of studentsDetails?.data){
                studentAdmissionNumbers.push({value:eachStudent.admissionNumber})
            }
            setAdmissions(studentAdmissionNumbers)
        }else{
            setAdmissions([])
            setSectionValue("")
            setIsClassSelected(true)
        }
    }

    const onChangeSection = (data) => {
        setSectionValue(data)
        if(data.value === "All"){
            setIsSectionSelected(false)
            const studentAdmissionNumbers = []
            for (let eachStudent of studentsDetails?.data){
                if(eachStudent.class === classValue.value){
                    studentAdmissionNumbers.push({value:eachStudent.admissionNumber})
                }
            }
            setAdmissions(studentAdmissionNumbers)
        }else{
            setAdmissions([])
            setIsSectionSelected(true)
        }
    }


    const studentNames = []

    for (let eachStudent of studentsDetails?.data) {
        if(eachStudent.class === classValue.value && eachStudent.section === sectionValue.value){
            studentNames.push({label:eachStudent.name+" : "+eachStudent.admissionNumber,value:eachStudent.admissionNumber})
        }
    }

    const values = [{ label: "Select All", value: "all" }, ...studentNames]

    const customStyles = {
        control: base => ({
          ...base,
          maxHeight: 150,
          overflow:"auto"
        })
      };

    const handleChange = arr => {

        console.log("arrr check",arr)
        // if(arr.length === (values.length-1)){
        //     setShowMenu(true)
        // }else{
        //     setShowMenu(false)
        // }
        setAdmissions(arr)
    };

    const onChangeHandler = (event) => {
        if(event.target.value === "Schedule"){
            setIsSchedule(true)
        }else{
            setIsSchedule(false)
        }
        setDate(event.target.value)
    }

    useEffect(() => {
        dispatch(getStudentsDetailsByBranch({branch: userDetails?.data?.branch}))
    },[])

    useEffect(() => {
        if (sendAnnouncementDetails.status === "succeeded") {
            setTimeout(() => {
                window.location.reload()
            }, 2500)
            showToast({ message: sendAnnouncementDetails.message })
            setAdmissions([])
            setTitle("")
            setMessage("")
            setEditorState(EditorState.createEmpty())
        }
        if(sendAnnouncementDetails.status === "failed"){
            showToast({message: sendAnnouncementDetails.message, type: 'error'})
        }
    }, [sendAnnouncementDetails])

    // console.log("admissions",admissions)

    const onClickSubmit = () => {
        const rawContentState = convertToRaw(editorState.getCurrentContent());
        const checkIfMessageIsEmpty = rawContentState?.blocks?.filter(eachBlock => eachBlock?.text !== "").length === 0 && Object.keys(rawContentState?.entityMap).length === 0
        if(isEmptyFields === false){
            if((title==="" || checkIfMessageIsEmpty || admissions.length === 0)){
                showToast({message: "Please fill all the fields", type: 'error'})
                const loginIntervalId = setInterval(() => {
                    clearInterval(loginIntervalId)
                    isEmptyFields = false
                }, 3200)
                isEmptyFields = true
            }else{
                const admissionNumbers = admissions?.map(each => each.value)
                const uniqueEmails = []  //for not sending multiple notifications to single parent
                let updatedAdmissionNumbers = []
                studentsDetails?.data?.map((eachStudent) => {
                    if(!uniqueEmails.includes(eachStudent.email) && admissionNumbers.includes(eachStudent.admissionNumber)){
                        uniqueEmails.push(eachStudent.email)
                        updatedAdmissionNumbers.push(eachStudent.admissionNumber)
                    } 
                })
                let scheduledDate;
                if(date === "Now"){
                    scheduledDate = date
                    // console.log("anouncement details",updatedAdmissionNumbers,admissionNumbers,admissions)
                    dispatch(sendAnnouncement({title,message,admissionNumbers:updatedAdmissionNumbers,scheduledDate}))
                }else{
                    if(scheduleDate === ""){
                        alert("Please Select a Valid date")
                    }else{
                        const d = new Date(scheduleDate);
                        scheduledDate = scheduleDate     
                        dispatch(sendAnnouncement({title,message,admissionNumbers:updatedAdmissionNumbers,scheduledDate}))
                    }
                }
            }
        }
    }

    console.log("detals///////",title,message)
  return (
    <>
    <Header />
    {(sendAnnouncementDetails?.status === 'loading' || studentsDetails?.status === 'loading') ? 
      
          (<div style={{ minHeight: '80vh' }} className='d-flex justify-content-center align-items-center'>
                <Spinner animation="border" role="status"></Spinner>
          </div>):
    <div className='px-5 d-flex flex-column mt-2 mb-2'>

        <div className="form-group">
            <label className="control-label" htmlFor="templates">Select Template</label>
            <select style={{ backgroundImage: 'none' }} value={templateValue} onChange={onChangeTemplate} className="form-control"  id='templates' name='templates' required>
                <option disabled selected hidden value="" >Select The Template</option>
                {filteredTemplates?.map((eachTemplate,i) => {
                    return <option key={i} value={eachTemplate.title}>{eachTemplate.title}</option>
                })}
            </select>
        </div>

        <div className="form-group">
            <label className="control-label" htmlFor="title">Enter Title</label>
            <input value={title}  onChange={(event) => {setTitle(event.target.value)}} placeholder='Enter Title' autoComplete='off' className="form-control" id='title' name='title' required />
        </div>
        <div className="form-group">
            <label className="control-label" htmlFor="message">Enter Message</label>
            {/* <input value={message} onChange={(event) => {setMessage(event.target.value)}} placeholder='Enter Message' autoComplete='off' className="form-control" id='message' name='message' required /> */}
            <Editor
                toolbar={{options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker', 'link', 'emoji', 'image', 'remove', 'history'],image: {uploadEnabled: false}}}
                name="message"
                wrapperStyle={{border:'1px solid #d6d6d6'}}
                editorStyle={{paddingLeft:'20px',paddingRight:'20px'}}
                editorState={editorState}
                onEditorStateChange={handleEditorChange}
            />
        </div>

        <div className='form-group'>
            <label className="control-label" htmlFor="classes">Select Classes</label>
            <Select
                maxMenuHeight='155px'
                options={classValues}
                className="basic-multi-select"
                classNamePrefix="select"
                value={classValue}
                styles={customStyles}
                minHeight="100px"
                onChange={onChangeClass}
            />
            {/* <select style={{ backgroundImage: 'none' }} value={classValue} onChange={onChangeClass} className="form-control"  id='class' name='class' required>
                <option disabled selected hidden value="" >Select The Class</option>
                <option value="All">All</option>
                {uniqueClasses?.map((eachClass,i) => {
                    return <option key={i} value={eachClass}>{eachClass}</option>
                })}
            </select> */}
        </div>


        {isClassSelected && 
            <div className='form-group'>
                <label className="control-label" htmlFor="classes">Select Sections</label>
                <Select
                    maxMenuHeight='155px'
                    options={sectionValues}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    value={sectionValue}
                    styles={customStyles}
                    minHeight="100px"
                    onChange={onChangeSection}
                />
                {/* <select style={{ backgroundImage: 'none' }} value={sectionValue} onChange={onChangeSection} className="form-control"  id='section' name='section' required>
                    <option disabled selected hidden value="" >Select The Section</option>
                    <option value="All">All</option>
                    {uniqueSections?.map((eachSection,i) => {
                        return <option key={i} value={eachSection}>{eachSection}</option>
                    })}
                </select> */}
            </div>
        }

        {isSectionSelected && sectionValue!=="" && 
            <div className="form-group">
                <label className="control-label" htmlFor="students">Select Students</label>
                <Select
                    maxMenuHeight='155px'
                    options={values}
                    isClearable={true}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    isMulti
                    value={admissions}
                    closeMenuOnSelect={false}
                    onChange={(selected) => {
                        console.log("selected",selected.find(e => e.value === 'all'))
                        selected.length &&
                        selected.find((option) => option.value === "all")
                        ? handleChange(values.slice(1))
                        : !true
                        ? handleChange((selected && selected.value) || null)
                        : handleChange(selected);
                    }}
                    styles={customStyles}
                    minHeight="100px"
                    />
            </div>
        }

        <div className="form-group">
            <label className="control-label" htmlFor="date">Schedule Message</label>
            <select style={{ backgroundImage: 'none' }} value={date} onChange={onChangeHandler} className="form-control"  id='date' name='date' required>
                <option value="Now" >Now</option>
                <option value="Schedule">Schedule</option>
            </select>
        </div>
        {isSchedule &&
        <div className="form-group schedule-input">
            <label className="control-label" htmlFor="message">Select Date</label>
            <input min={new Date(new Date().getTime() + 24 * 60 * 60 * 1000).toISOString().slice(0, 10)} onChange={(event) => setScheduleDate(event.target.value)} type="date" placeholder='Enter Message' autoComplete='off' className="form-control" />
        </div>
        }
        <button onClick={onClickSubmit} className='btn btn-primary align-self-end'>Submit</button>
    
    </div>}
    </>
  )
}

export default Announcements